import { goalsService } from 'src/config/rootService';

import { GoalInterest, TopicOfFocus } from '../models/goals';

export type GoalInterestsState = {
    oldGoalsAndInterests: GoalInterest[];
    topicsOfFocus: TopicOfFocus[];
} | null; // null is used as a isFetching flag

const defaultState: GoalInterestsState = null;

export const goalInterests = {
    state: defaultState,
    reducers: {
        saveOldInterests: (state, payload: GoalInterest[] = []): GoalInterestsState => {
            return {
                ...state,
                oldGoalsAndInterests: payload,
            };
        },
        'authentication/logout': () => {
            return defaultState;
        },
    },
    effects: dispatch => ({
        async fetchGoalInterests(): Promise<void> {
            const interests = await goalsService.fetchGoalInterests();

            dispatch.goalInterests.saveOldInterests(interests);
        },
        async saveGoalInterests(payload: number[]): Promise<void> {
            const interests = await goalsService.saveGoalsInterests(payload);

            dispatch.goalInterests.saveOldInterests(interests);
        },
    }),
};
